var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-wrapper page-wrapper--fill-space"},[_c('grid-single-column-center',[_c('div',{staticClass:"text-center display-3 font-weight-light"},[_vm._v(" 404! not found ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }